<mat-dialog-content>
  <mat-card-title>{{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvers'| eCaseTranslate }}</mat-card-title>

  <table mat-table class="ecase-mat-table"
         style="margin-top: 0px"
         id="ecase_admindashboard_eligibility_awf_AWFDocument_approvers_table"
         [dataSource]="dataSource"
         [@animateStagger]="{value:'50'}"
         matSortActive="{{sortActive}}"
         (matSortChange)="sortColumn($event)"
         matSortDirection="{{sortDirection}}"
         matSort>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <u>{{
            'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.name' |
              translate
          }}</u></th>
      <ng-container *matCellDef="let row">
        <td mat-cell [title]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.name' | translate">
          {{ row.name }}
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="approvalLevel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <u>{{
            'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalLevel' |
              translate
          }}</u></th>
      <ng-container *matCellDef="let row">
        <td mat-cell
            [title]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalLevel' | translate">
          {{ row.approvalLevel }}
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="isApprovalProcessed">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><u>
        {{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalStatus' |translate }}</u></th>
      <ng-container *matCellDef="let row">
        <td mat-cell
            [title]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalStatus' | translate">
          <div style="padding: 5px"
               *ngIf="row.isApprovalProcessed === 1">
            <span>
              {{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.completed' | eCaseTranslate }}
              ({{
                row.isApprovalGiven ? ('ecase.admindashboard.eligibility.awf.AWFDocument.approval.approved' | eCaseTranslate)
                  : ('ecase.admindashboard.eligibility.awf.AWFDocument.approval.rejected' | eCaseTranslate)
              }})
             </span>
          </div>
          <span style="padding: 5px"
                *ngIf="row.isApprovalProcessed === 0">{{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.inprogress' | eCaseTranslate }}</span>
          <span style="padding: 5px"
                *ngIf="row.isApprovalProcessed === 2">{{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.cancelled' | eCaseTranslate }}</span>
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="comments">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><u>
        {{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.comments' |translate }}
      </u></th>
      <ng-container *matCellDef="let row">
        <td mat-cell
            [title]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.comments' | translate">
          {{ row.comments }}
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="formattedApprovalDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><u>
        {{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalDate' |translate }} <br>
        ({{ 'ecase.defaultDatetimeWithMinutes' | translate }})</u></th>
      <ng-container *matCellDef="let row">
        <td mat-cell
            [title]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalDate' | translate">
          {{ row.formattedApprovalDate }}
        </td>
      </ng-container>
    </ng-container>

    <!-- Header row first group -->
    <ng-container class="filter_row_first_cell mat-elevation-z4" matRipple matColumnDef="header-row-first-group">
      <th mat-header-cell *matHeaderCellDef
          class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.</span>
        <input type="image" *ngIf="showImage" disabled
               matRipple class="row_filter_icon"
               src="../../../../../assets/images/etc/icons8-conversion.svg" alt="clear">
        <input type="image" *ngIf="!showImage" class="row_filter_icon"
               src="../../../../../assets/images/etc/icons8-clear-filters.svg" alt="clear" (click)="resetFilters(true)">
        <input type="text" class="searchFields"
               id="ecase_e_signature_table_name_filter"
               [attr.aria-label]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.name' | eCaseTranslate"
               [(ngModel)]="filterObject.name"
               [placeholder]="'ecase.admindashboard.search' | eCaseTranslate"
               (keyup)="applyFilter()">
      </th>
    </ng-container>

    <ng-container matColumnDef="header-row-second-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell"><span class='nodisplay'>.</span>
        <input type="text" class="searchFields"
               id="ecase_e_signature_table_level_filter"
               [attr.aria-label]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalLevel' | eCaseTranslate"
               [(ngModel)]="filterObject.approvalLevel"
               [placeholder]="'ecase.admindashboard.search' | eCaseTranslate"
               (keyup)="applyFilter()">
      </th>
    </ng-container>


    <ng-container matColumnDef="header-row-third-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell">
        <span class='nodisplay'>.</span>

        <div class="form-item" style="margin: 0 !important;">
          <div class="select-wrap">
            <select class="select_filter filter-items__element--select" required
                    id="ecase_admindashboard_eligibility_awf_AWFDocument_approvalStatus"
                    [attr.aria-label]="'ecase.admindashboard.eligibility.awf.AWFDocument.approvalStatus' | eCaseTranslate"
                    [(ngModel)]="filterObjectForSelectFields.isApprovalProcessed"
                    (change)="applyFilter()">
              <option role="option" selected value="">
                {{ 'ecase.admindashboard.select' | eCaseTranslate }}
              </option>
              <option
                [value]="2">{{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.cancelled' | eCaseTranslate }}
              </option>
              <option
                [value]="1">{{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.completed' | eCaseTranslate }}
              </option>
              <option
                [value]="0">{{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.inprogress' | eCaseTranslate }}
              </option>
            </select>
          </div>
        </div>
      </th>
    </ng-container>
    <ng-container matColumnDef="header-row-fourth-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell"><span class='nodisplay'>.</span>
        <input type="text" class="searchFields"
               id="ecase_e_signature_table_comments_filter"
               [attr.aria-label]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.comments' | eCaseTranslate"
               [(ngModel)]="filterObject.comments"
               [placeholder]="'ecase.admindashboard.search' | eCaseTranslate"
               (keyup)="applyFilter()">
      </th>
    </ng-container>

    <ng-container matColumnDef="header-row-fifth-group">
      <th mat-header-cell *matHeaderCellDef class="mat-table_filtered_header_cell"><span class='nodisplay'>.</span>
        <input type="text" class="searchFields"
               id="ecase_e_signature_table_date_filter"
               [attr.aria-label]="'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.approvalDate' | eCaseTranslate"
               [(ngModel)]="filterObject.formattedApprovalDate"
               [placeholder]="'ecase.admindashboard.search' | eCaseTranslate"
               (keyup)="applyFilter()">
      </th>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-header-row
        *matHeaderRowDef="['header-row-first-group', 'header-row-second-group', 'header-row-third-group', 'header-row-fourth-group', 'header-row-fifth-group']"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator *ngIf="approvers.length > 0" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                 showFirstLastButtons></mat-paginator>
</mat-dialog-content>
<mat-dialog-actions>
  <div style="width: 100%">
    <button style="float: right" class="eCase-dialog-negative-action-button" (click)="onClose()"
            mat-button>
      {{ 'ecase.admindashboard.eligibility.awf.AWFDocument.approval.dialog.close' | translate }}
    </button>
  </div>
</mat-dialog-actions>
